import classNames from "classnames";
import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { installationConfig } from "@/shared/constants/installation-config";
import { setBackgroundMobile } from "../helpers/setBackground";
import { Footer } from "../Components/Footer";
import styles from "./styles.module.scss";

export const RegistrationPageMobile = () => {
  useEffect(() => {
    setBackgroundMobile();
  });

  return (
    <div
      id="login-page"
      className={classNames(styles.root, {
        [styles["root-crescendo"]]: installationConfig.name === "Crescendo",
      })}
    >
      <Outlet />
      <Footer />
    </div>
  );
};
